export const SLIDING_WARDROBES_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    price: 54261,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1027,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['2.jpg/2.jpg'],
    price: 73800,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1009,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['3.jpg/3.jpg'],
    price: 68782,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1033,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['4.jpg/4.jpg'],
    price: 92768,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1015,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['5.jpg/5.jpg'],
    price: 89000,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1006,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['6.jpg/6.jpg'],
    price: 116834,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1003,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['7.jpg/7.jpg'],
    price: 78894,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1031,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['8.jpg/8.jpg'],
    price: 71666,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1026,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['9.jpg/9.jpg'],
    price: 97475,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1021,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['10.jpg/10.jpg'],
    price: 95000,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1018,
  },
  {
    displayedName: 'Шкафы-купе',
    mediaMainPhoto: ['11.jpg/11.jpg'],
    price: 95500,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1012,
  },
];